import { AI_ACTION_TYPES } from "../actions/actions_ai_type";

const initialState = {
  createAiHeaderData: null,
  headerDataForParticular: null,
  updatedAiHeaderData: null,
  createAiBodyData: null,
  bodyDataForParticular: null,
  updatedAiBodyData: null,
  createAiFooterData: null,
  footerDataForParticular: null,
  updatedAiFooterData: null,
  check_structure_ai_id: null,
  ongoing_ai_id: "",
  all_ai_data: null,
  allAgentDetails: [],
  allAssignedCampaignsDetails: [],
  createdAgentResponse: "",
  aiAgentDataById: null,
  unassignedCampaigns: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case AI_ACTION_TYPES.CREATE_AI_HEADER_SECTION_LOADED:
      return {
        ...state,
        createAiHeaderData: action.payload,
      };
    case AI_ACTION_TYPES.GET_HEADER_DATA_FOR_PARTICULAR:
      return {
        ...state,
        headerDataForParticular: action.payload,
      };
    case AI_ACTION_TYPES.SET_HEADER_DATA_NULL:
      return {
        ...state,
        headerDataForParticular: null,
      };
    case AI_ACTION_TYPES.UPDATE_AI_HEADER_DATA_SECTION:
      return {
        ...state,
        updatedAiHeaderData: action.payload,
      };
    case AI_ACTION_TYPES.CREATE_AT_BODY_SECTION_LOADED:
      return {
        ...state,
        createAiBodyData: action.payload,
      };
    case AI_ACTION_TYPES.GET_BODY_DATA_FOR_PARTICULAR:
      return {
        ...state,
        bodyDataForParticular: action.payload,
      };
    case AI_ACTION_TYPES.SET_BODY_DATA_NULL:
      return {
        ...state,
        bodyDataForParticular: null,
      };
    case AI_ACTION_TYPES.UPDATE_AI_BODY_DATA_SECTION:
      return {
        ...state,
        updatedAiBodyData: action.payload,
      };
    case AI_ACTION_TYPES.CREATE_AT_FOOTER_SECTION_LOADED:
      return {
        ...state,
        createAiFooterData: action.payload,
      };
    case AI_ACTION_TYPES.GET_FOOTER_DATA_FOR_PARTICULAR:
      return {
        ...state,
        footerDataForParticular: action.payload,
      };
    case AI_ACTION_TYPES.SET_FOOTER_DATA_NULL:
      return {
        ...state,
        footerDataForParticular: null,
      };
    case AI_ACTION_TYPES.UPDATE_AI_FOOTER_DATA_SECTION:
      return {
        ...state,
        updatedAiFooterData: action.payload,
      };
    case AI_ACTION_TYPES.CHECK_DATA_STRUCTURE_BY_AI_ID:
      return {
        ...state,
        check_structure_ai_id: action.payload,
      };
    case AI_ACTION_TYPES.ONGOING_AGENTID:
      return {
        ...state,
        ongoing_ai_id: action.payload,
      };
    case AI_ACTION_TYPES.GET_ALL_AI_DATA:
      return {
        ...state,
        all_ai_data: action.payload,
      };
    case AI_ACTION_TYPES.GET_ALL_AGENT_DETAILS:
      return {
        ...state,
        allAgentDetails: action.payload,
      };
    case AI_ACTION_TYPES.GET_ASSIGNED_CAMPAIGNS:
      return {
        ...state,
        allAssignedCampaignsDetails: action.payload,
      };
    case AI_ACTION_TYPES.GET_CREATED_AGENT_RESPONSE:
      return {
        ...state,
        createdAgentResponse: action.payload,
      };
    case AI_ACTION_TYPES.GET_AI_AGENT_DATA_BY_ID:
      return {
        ...state,
        aiAgentDataById: action.payload,
      };
    case AI_ACTION_TYPES.GET_UNASSIGNED_CAMPAIGNS:
      return {
        ...state,
        unassignedCampaigns: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
